<<!-- 个人概览-->
<template>
  <div class="line-14 text-l pb-40 default">
    <el-row class="fz-14 c-000 line-22 mb-20 mt-24">欢迎您, {{nickname}}</el-row>
    <div >
      <el-row>
        <el-col :span="24" class="center flex c-fff">
          <el-col :span="4" class="over-k radius-8 b-878">
            <div class="fz-40 line-56 mt-20 mb-12">{{total.online_article}}</div>
            <div class="line-22 fz-14">当前在线(个)</div>
          </el-col>
          <el-col :span="4" class="over-k radius-8 b-409 ml-49">
            <div class="fz-40 line-56 mt-20 mb-12">{{total.wait_article}}</div>
            <div class="line-22 fz-14">待审核(个)</div>
          </el-col>
          <el-col :span="4" class="over-k radius-8 b-41c ml-49">
            <div class="fz-40 line-56 mt-20 mb-12">{{total.today_access}}</div>
            <div class="line-22 fz-14">今日通过(个)</div>
          </el-col>
          <el-col :span="4" class="over-k radius-8 b-ea5 ml-49 mr-49">
            <div class="fz-40 line-56 mt-20 mb-12">{{total.today_refuse}}</div>
            <div class="line-22 fz-14">今日拒绝(个)</div>
          </el-col>
          <el-col :span="4" class="over-k radius-8 b-fba">
            <div class="fz-40 line-56 mt-20 mb-12">{{total.will_fail}}</div>
            <div class="line-22 fz-14">即将到期(个)</div>
          </el-col>
        </el-col>
      </el-row>
      <el-row class="line-28 c-000 fz-14 mt-44 mb-10">优惠提报</el-row>
      <el-row class="line-22 fz-14">
        30天内共提报
        <span class="c-ea4">{{total.thirty_create_article}}</span>条，发布
        <span class="c-ea4">{{total.thirty_access_article}}</span>条，发布率
        <span class="c-ea4">{{total.thirty_access_probability}}%</span>
      </el-row>
      <el-row class="flex fz-14 c-000 line-22 flex-al mt-20">
        <div class="over-l mr-6"></div>
        <div>30天内提报情况</div>
      </el-row>
      <el-row class="flex-al fz-13 line-22 mt-15">
        <div class="w-164">提交</div>
        <div class="pos-r over-line">
          <div class="pos-a radius-8 over-bg" :style="thirty_create_article"></div>
        </div>
        <div class="ml-16">{{total.thirty_create_article}}条</div>
      </el-row>
      <el-row class="flex-al fz-13 line-22 mt-15">
        <div class="w-164">审核通过</div>
        <div class="pos-r over-line">
          <div class="pos-a radius-8 over-bg" :style="thirty_access_article"></div>
        </div>
        <div class="ml-16">{{total.thirty_access_article}}条</div>
      </el-row>
      <el-row class="flex-al fz-13 line-22 mt-15">
        <div class="w-164">审核拒绝</div>
        <div class="pos-r over-line">
          <div class="pos-a radius-8 over-bg" :style="thirty_refuse"></div>
        </div>
        <div class="ml-16">{{total.thirty_refuse}}条</div>
      </el-row>
      <el-row class="flex-al fz-13 line-22 mt-15">
        <div class="w-164">发布到什么值得买</div>
        <div class="pos-r over-line">
          <div class="pos-a radius-8 over-bg" :style="thirty_smzdm_access"></div>
        </div>
        <div class="ml-16">{{total.thirty_smzdm_access}}条</div>
      </el-row>

      <!-- <el-row class="flex-al fz-13 line-22 mt-15" v-if="isvip==2">
        <div class="w-164">标记为精选或同步至首页</div>
        <div class="pos-r over-line">
          <div class="pos-a radius-8 over-bg" :style="thirty_smzdm_home"></div>
        </div>
        <div class="ml-16">{{total.thirty_smzdm_home}}条</div>
      </el-row> -->
    </div>
  </div>
</template>

<script>
import "./tool.css";
export default {
  name: "overview",
  data() {
    return {
      api: {
        create_article_surcey: "/home/create_article_surcey" //提报概况
      },
      nickname: "",
      total: {
        online_article: 0,
        wait_article: 0,
        today_access: 0,
        today_refuse: 0,
        will_fail: 0,
        thirty_create_article: 0,
        thirty_access_article: 0,
        thirty_access_probability: 0,
        thirty_refuse: 0,
        thirty_smzdm_access: 0
      },
      thirty_create_article: {
        width: ""
      },
      thirty_access_article: {
        width: ""
      },
      thirty_refuse: {
        width: ""
      },
      thirty_smzdm_access: {
        width: ""
      },
      thirty_smzdm_home: {
        width: ""
      }
    };
  },
  components: {},
  created() {
    this.getUser();
    this.infoMation();
  },
  mounted() {},
  methods: {
    getUser() {
      if (this.$http.getAuth("user_info")) {
        this.nickname = this.$http.getAuth("user_info").nickname;
      }
    },

    infoMation() {
      let _this = this;
      let data = {};
      _this
        .$http({
          method: "GET",
          url: _this.api.create_article_surcey,
          params: data
        })
        .then(res => {
          if (res.code == 1) {
            _this.total = res.data;
            if (res.data.thirty_create_article) {
              _this.thirty_create_article.width = "100%";
            } else {
              _this.thirty_create_article.width = "0px";
            }
            if (res.data.thirty_access_article) {
              _this.thirty_access_article.width =
                (res.data.thirty_access_article /
                  res.data.thirty_create_article) *
                  100 +
                "%";
            } else {
              _this.thirty_access_article.width = "0px";
            }
            if (res.data.thirty_refuse) {
              _this.thirty_refuse.width =
                (res.data.thirty_refuse / res.data.thirty_create_article) *
                  100 +
                "%";
            } else {
              _this.thirty_refuse.width = "0px";
            }
            if (res.data.thirty_smzdm_home) {
              _this.thirty_smzdm_home.width =
                (res.data.thirty_smzdm_home / res.data.thirty_create_article) *
                  100 +
                "%";
            } else {
              _this.thirty_smzdm_home.width = "0px";
            }
            if (res.data.thirty_smzdm_access) {
              _this.thirty_smzdm_access.width =
                (res.data.thirty_smzdm_access /
                  res.data.thirty_create_article) *
                  100 +
                "%";
            } else {
              _this.thirty_smzdm_access.width = "0px";
            }
          } else {
            console.log(rea.msg);
          }
        });
    }
  }
};
</script>
<style  scoped>
.over-k {
  width: 160px;
  height: 130px;
}
.over-l {
  width: 5px;
  height: 12px;
  background: #409eff;
  border-radius: 8px;
}
.over-line {
  width: 357px;
  height: 10px;
  border-radius: 8px;
  background: #ebeef5;
}
.over-bg {
  background: #ea4c51;
  height: 100%;
  left: 0;
}
.w-164 {
  width: 164px;
}
.huanying{
  height:500px;
}
</style>